import { c as _c } from "react/compiler-runtime";
import type { InputHTMLAttributes } from 'react';
import { Typography } from '@/components/Typography';
import { CountryFlag } from '@/components/icons/CountryFlag';
import type { Region } from '@/services/rental-api-client';
import { LocationSelectListItem } from './LocationSelectListItem';
export type LocationSelectListProps = {
  regions: Region[];
  name: string;
  value?: InputHTMLAttributes<HTMLInputElement>['value'];
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
};
export function LocationSelectList(t0) {
  const $ = _c(11);
  const {
    regions,
    name: t1,
    value,
    onChange
  } = t0;
  const name = t1 === undefined ? "location" : t1;
  let t2;
  if ($[0] !== name || $[1] !== onChange || $[2] !== regions || $[3] !== value) {
    let t3;
    if ($[5] !== name || $[6] !== onChange || $[7] !== value) {
      t3 = region => <div key={region.countryCode}><div className="px-4 pt-4 pb-2 sticky top-0 bg-white z-10 mr-2"><Typography variant="caption" as="div" className="inline-block rounded px-2 py-0.5 bg-base-150"><CountryFlag countryCode={region.countryCode} className="text-base mr-1" /> {region.country}</Typography></div><div className="flex flex-col pr-4 mr-1">{region.sites.map(site => <LocationSelectListItem as="label" key={site.siteCode} className="px-3.5 h-13 has-checked:border-active hover:not-has-checked:bg-primary-accent input-focus-transition user-select-none cursor-pointer" tabIndex={0} site={site} role="radio" aria-checked={value === site.siteCode} data-testid={`location-radio-${site.siteCode}`}><input name={name} type="radio" className="hidden" value={site.siteCode} checked={value === site.siteCode} onChange={onChange} /></LocationSelectListItem>)}</div></div>;
      $[5] = name;
      $[6] = onChange;
      $[7] = value;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = regions.map(t3);
    $[0] = name;
    $[1] = onChange;
    $[2] = regions;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <>{t2}</>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}